<div class="reviewer-node-container">
  <div class="reviewer-node">
    <div class="avatar">{{ (reviewer?.user?.name || documentNode?.content || 'A').charAt(0) }}</div>
    <div class="details">
      <div class="name">{{ reviewer?.user?.name || documentNode?.content || 'Unassigned reviewer' }}</div>
      @if (reviewer?.user?.email) {
        <div class="meta">{{ reviewer.user.email }}</div>
      }
    </div>
  </div>
  @if (editMode && !isAssignedCurrentUser) {
    <div class="reviewer-actions">
      <button mat-mini-fab color="primary" matTooltip="Edit reviewer" aria-label="Edit reviewer" (click)="editReviewer()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-mini-fab color="warn" matTooltip="Remove reviewer" aria-label="Remove reviewer" (click)="removeReviewer()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }
  @if (documentNode.comments?.length > 0) {
    @for (comment of documentNode.comments; track comment) {
      <app-comment-rail [nodeId]="documentNode?.id" [reviewerMode]="false" [comment]="comment"></app-comment-rail>
    }
  }
</div>
